import { RetargetingConditionData } from '../../typings/retargeting';

export const UPDATE_GROUP_AUDIENCE_RETARGETING_EDITOR_CONDITION = 'UPDATE_GROUP_AUDIENCE_RETARGETING_EDITOR_CONDITION';
export type UPDATE_GROUP_AUDIENCE_RETARGETING_EDITOR_CONDITION = typeof UPDATE_GROUP_AUDIENCE_RETARGETING_EDITOR_CONDITION;

export interface UpdateGroupAudienceRetargetingEditorCondition {
    type: UPDATE_GROUP_AUDIENCE_RETARGETING_EDITOR_CONDITION;
    groupId: string;
    conditionData: RetargetingConditionData;
}

export function updateGroupAudienceRetargetingEditorCondition(
    groupId: string,
    conditionData: RetargetingConditionData
): UpdateGroupAudienceRetargetingEditorCondition {
    return {
        type: UPDATE_GROUP_AUDIENCE_RETARGETING_EDITOR_CONDITION,
        groupId,
        conditionData
    };
}

export const CLEAR_GROUP_AUDIENCE_RETARGETING_EDITOR_CONDITION = 'CLEAR_GROUP_AUDIENCE_RETARGETING_EDITOR_CONDITION';
export type CLEAR_GROUP_AUDIENCE_RETARGETING_EDITOR_CONDITION = typeof CLEAR_GROUP_AUDIENCE_RETARGETING_EDITOR_CONDITION;

export interface ClearGroupAudienceRetargetingEditorCondition {
    type: CLEAR_GROUP_AUDIENCE_RETARGETING_EDITOR_CONDITION;
    groupId: string;
}

export function clearGroupAudienceRetargetingEditorCondition(
    groupId: string
): ClearGroupAudienceRetargetingEditorCondition {
    return {
        type: CLEAR_GROUP_AUDIENCE_RETARGETING_EDITOR_CONDITION,
        groupId
    };
}

export const OPEN_AUDIENCE_RETARGETING_EDITOR = 'OPEN_AUDIENCE_RETARGETING_EDITOR';
export type OPEN_AUDIENCE_RETARGETING_EDITOR = typeof OPEN_AUDIENCE_RETARGETING_EDITOR;

export interface OpenAudienceRetargetingEditor {
    type: OPEN_AUDIENCE_RETARGETING_EDITOR;
    groupId: string;
    conditionData: RetargetingConditionData;
}

export function openAudienceRetargetingEditor(
    groupId: string,
    conditionData: RetargetingConditionData
): OpenAudienceRetargetingEditor {
    return {
        type: OPEN_AUDIENCE_RETARGETING_EDITOR,
        groupId,
        conditionData
    };
}

export const RESET_AUDIENCE_RETARGETING_EDITOR = 'RESET_AUDIENCE_RETARGETING_EDITOR';
export type RESET_AUDIENCE_RETARGETING_EDITOR = typeof RESET_AUDIENCE_RETARGETING_EDITOR;

export interface ResetAudienceRetargetingEditor {
    type: RESET_AUDIENCE_RETARGETING_EDITOR;
    groupId: string;
}

export function resetAudienceRetargetingEditor(groupId: string): ResetAudienceRetargetingEditor {
    return {
        type: RESET_AUDIENCE_RETARGETING_EDITOR,
        groupId
    };
}

export type RetargetingConditionsForAudienceEditorAction =
    | UpdateGroupAudienceRetargetingEditorCondition
    | ClearGroupAudienceRetargetingEditorCondition
    | OpenAudienceRetargetingEditor
    | ResetAudienceRetargetingEditor;
